import React from 'react';

const BtnIcon = (props) => {

  const WrapBtns = (props) => {
    return (
    <a 
      className = {`BtnIcon ${props.className}`} 
      href={props.href} 
      target={props.target}
      rel="noopener noreferrer" 
      onClick ={props.onClick}
      download = {props.download}
    >
      {props.children} 
    </a>
    )
  }

  return (
    <WrapBtns {...props} >
    
      <img src={props.image} alt={props.name}/>
    
    </WrapBtns>
  );
}

export default BtnIcon;